const INITIAL_STATE = {
  name: "HAssan",
};

export default (state = INITIAL_STATE, action) => {
  return state;
};
